import { entityKeyOf, entitySegment, isKnownModule, moduleKeyOf } from '@platform/core/lib/modulePaths';
import { routes } from '@platform/core/lib/routes';

/**
 * Канонічна адреса сторінки модуля (ADR-028) або null, якщо адреса вже канонічна: модуль шукається за slug, група перевіряється м'яко —
 * інша група (зміна категорії власного модуля, рукописна адреса) чи ключ сутності замість slug замінюються канонічними, решта шляху
 * лишається. Модуль, ще не відомий (власний модуль до завантаження каталогу), — без змін.
 */
export function canonicalModulePath(pathname: string): string | null {
  const [, group, slug, segment, ...rest] = pathname.split('/');
  if (!group || !slug) return null;
  const key = moduleKeyOf(slug);
  if (!isKnownModule(key)) return null;
  const rt = segment ? entityKeyOf(key, segment) : undefined;
  const path = [routes.module(key), ...(segment ? [rt ? entitySegment(key, rt) : segment] : []), ...rest].join('/');
  return path === pathname ? null : path;
}
